/** How many recently visited screens stay mounted so list state survives a detail visit. */
export const LIST_VIEW_CACHE_LIMIT = 8;

/**
 * Most-recent path is last. The active path is always retained.
 * Older screens drop off the front once the limit is reached.
 */
export function rememberListPaths(
  history: readonly string[],
  pathname: string,
  limit = LIST_VIEW_CACHE_LIMIT
): string[] {
  const next = [...history.filter((path) => path !== pathname), pathname];
  const seen = new Set<string>();
  const uniqueFromEnd: string[] = [];
  for (let i = next.length - 1; i >= 0; i -= 1) {
    const path = next[i];
    if (seen.has(path)) continue;
    seen.add(path);
    uniqueFromEnd.push(path);
  }
  uniqueFromEnd.reverse();
  if (uniqueFromEnd.length <= limit) return uniqueFromEnd;
  return uniqueFromEnd.slice(uniqueFromEnd.length - limit);
}

/** True when `from` is a record opened from the list at `listPath`. */
export function shouldRestoreListSearch(from: string, listPath: string): boolean {
  return from.startsWith(`${listPath}/`);
}
